export const GRID_COLUMNS = 3
